import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  wrapperLink: ({ spacing }) => css`
    p {
      display: flex;
    }
    svg {
      margin-right: ${spacing.xxs};
    }
  `,

  wrapperConfirmed: ({ spacing, grid, fontSizes }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: ${spacing.md};
    > p {
      margin-top: ${spacing.xs};
      text-align: center;
      @media (max-width: ${grid.breakpoint.md}) {
        font-size: ${fontSizes['2xl']};
        line-height: ${spacing.md};
      }
    }
  `,

  subtitle: ({ spacing }) => css`
    margin-top: ${spacing.sm};
  `,

  containerCards: css`
    display: flex;
    flex-wrap: wrap;
  `,

  wrapperResumeCard: ({ spacing }) => css`
    margin-right: ${spacing.md};
  `,

  wrapperCard: ({ spacing }) => css`
    margin-top: ${spacing.xs};
  `,

  linkFooter: ({ spacing, fontSizes }) => css`
    font-size: ${fontSizes.sm};
    text-align: center;
    padding: ${spacing.md};
  `,
})

export default useStyles
